var addressForm = document.getElementById("address__form--add");
var addressFormButton = document.getElementById("add__address");
var addressFormCancel = document.getElementById("canceladd__address");
var addressFormToggle = false;

if (addressFormButton !== null) {
  addressFormButton.onclick = function () {
    addressFormToggle = true;
    toggleAddressForm();
  };
}
if (addressFormCancel !== null) {
  addressFormCancel.onclick = function () {
    addressFormToggle = false;
    toggleAddressForm();
  };
}

function toggleAddressForm() {
  if (addressFormToggle) {
    addressForm.classList.add("form__show");
  } else {
    addressForm.classList.remove("form__show");
  }
}

var addresses = Array.from(document.getElementsByClassName("addresses__item"));

addresses.forEach(function (address, i) {
  var editButton = address.querySelector(".edit__address");
  var submitButton = address.querySelector(".update__address");
  var cancelButton = address.querySelector(".cancelupdate__address");
  var editAddressForm = address.querySelector(".addresses__item--update");
  var formToggle = false;

  editButton.onclick = function () {
    formToggle = true;
    toggleForm();
  };
  submitButton.onclick = function () {
    formToggle = false;
    toggleForm();
  };
  cancelButton.onclick = function () {
    formToggle = false;
    toggleForm();
  };

  function toggleForm() {
    if (formToggle) {
      editAddressForm.classList.add("form__show");
    } else {
      editAddressForm.classList.remove("form__show");
    }
  }
});
